// Define Days and months
var m_names = ["January", "February", "March",
"April", "May", "June", "July", "August", "September",
"October", "November", "December"];

var d_names = ["Sunday", "Monday", "Tuesday", "Wednesday",
"Thursday", "Friday", "Saturday"];

// Get today's date and time
var now = new Date();
var firstDay = new Date(now); // Usamos now para asegurar copias de la fecha actual
var lastDay = new Date(now);

// Define shipping minimum and maximum days
var daysMinimum = 1;
var daysMaximum = 3;

// Define dates of estimate shipping
firstDay.setDate(now.getDate() + daysMinimum);
lastDay.setDate(now.getDate() + daysMaximum);

// Avoid Saturdays & Sundays for firstDay
if (firstDay.getDay() == 6) {
    firstDay.setDate(firstDay.getDate() + 2);
    lastDay.setDate(lastDay.getDate() + 2);
} else if (firstDay.getDay() == 0) {
    firstDay.setDate(firstDay.getDate() + 1);
    lastDay.setDate(lastDay.getDate() + 1);
}

// Avoid Saturdays & Sundays for lastDay
if (lastDay.getDay() == 6) {
    lastDay.setDate(lastDay.getDate() + 2);
} else if (lastDay.getDay() == 0) {
    lastDay.setDate(lastDay.getDate() + 1);
}

// Translate dates to text
var firstDay_day = firstDay.getDate();
var firstDay_month = firstDay.getMonth();
var firstDay_word = firstDay.getDay();

var lastDay_day = lastDay.getDate();
var lastDay_month = lastDay.getMonth();
var lastDay_word = lastDay.getDay();

// Display the result in the element with id="shipping_date"
document.getElementById("shipping_date").innerHTML = "Place your order now and receive it between " + d_names[firstDay_word] + " " + firstDay_day + " " + m_names[firstDay_month] + " and " + d_names[lastDay_word] + " " + lastDay_day + " " + m_names[lastDay_month];